export default {
  text: 'Je hebt minder dan 15 minuten geleden een bestelling geplaatst! Bevestig of je wilt doorgaan met deze nieuwe bestelling of je bestaande wilt beheren.',
  buttons: {
    see_existing_order: 'Bestaande bestelling bekijken',
    proceed_new_order: 'Doorgaan met nieuwe bestelling',
  },
};
